import React from 'react';
import {action, observable, computed} from 'mobx';
import {Link} from 'react-router';
import FolderModel from '../models/FolderModel';
import BaseStore from './BaseStore';

class FolderStore extends BaseStore {
  stationStore;

  constructor(transportLayer, stationStore) {
    super(FolderModel, transportLayer);
    this.stationStore = stationStore;
  }

  @observable searchFilter = '';

  @action setSearchFilter(searchFilter) {
    this.searchFilter = searchFilter;
  }

  processFolderHierarchy(dataArray) {
    const data = dataArray;

    const arr = [];

    data.forEach(project => {
      project && arr.push({
        type: 'PROJECT',
        level: 1,
        key: project.id,
        slug: 'folder',
        childSlug: `folder/${project.id}/station`,
        id: project.id,
        name: project.name,
        project: `${project.name} (${project.id})`,
        station: null,
        description: project.description,
        total_stations: (project && project.stations && project.stations.length) || 0,
        project_id: project.id,
      });
      project.stations && project.stations.forEach(station => {
        arr.push({
          type: 'STATION',
          level: 2,
          key: `${project.id}.${station.id}`,
          // slug: 'station',
          slug: `folder/${project.id}/station`,
          id: station.id,
          name: `  ${station.name}`,
          project: null,
          station: <Link to={`/station/${station.id}`}>{station.name} ({station.id})</Link>,
          description: station.description,
          total_stations: null,
          project_id: project.id,
          parent_id: project.id,
        });
      });
    });

    return arr;
  }

  @computed get tableData() {
    return this.processFolderHierarchy(this.items);
  }

  @action updateStation(station, folderId){
    let folder = this.items.filter(item => +item.id === +folderId)[0];
    let stationIndex = folder.stations.indexOf(folder.stations.filter(param => +param.id === +station.id)[0]);
    if(stationIndex>-1){
      this.items.filter(item => +item.id === +folderId)[0].stations[stationIndex] = station;
    }else{
      this.items.filter(item => +item.id === +folderId)[0].stations.push(this.stationStore.items.filter(p => +p.id === +station.id)[0]);
    }
  }

  @action removeStation(folderId, stationId){
    this.items.find(folder => +folder.id === +folderId).stations = this.items.find(folder => +folder.id === +folderId).stations.filter(station => +station.id !== +stationId)
  }
}

export default FolderStore;



// WEBPACK FOOTER //
// ./src/stores/FolderStore.js